export type FontWeight = 'normal' | 'semibold' | 'bold';

export type FontWeights = Record<FontWeight, number>;

export const fontWeights: FontWeights = {
  normal: 400,
  semibold: 600,
  bold: 600,
};
